/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Button = styled.a`
   ${t.mixins.flex()}
   padding: 13px 8px 13px 13px;
   margin-bottom: 4px;
   ${t.mixins.rem(14, 14)}
   font-family: ${t.font.primary};
   font-weight: ${t.font.bold};
   text-transform: uppercase;
   border-radius: 2px;
   background-color: ${t.color.greyDisabled};
   color: ${t.color.white};
   text-decoration: none;
   cursor: not-allowed;
 
   ${t.mixins.sm(`
     padding: 9px;
   `)}
 `;
const Title = styled.span`
  text-transform: uppercase;
  ${t.mixins.sm(`
     ${t.mixins.rem(13, 13)}
     text-align: center;
   `)}
`;

/**
 * external component is..
 */

const Button__disabled = ({ title, href }) => (
  <Button href={href} target="_blank">
    <Title>{title}</Title>
  </Button>
);

export default Button__disabled;

Button__disabled.propTypes = {
  /**
       A custom style object
       */
  style: PropTypes.object,
};

Button__disabled.defaultProps = {
  style: {},
};

/*
     import Button__disabled from 'components/button/disabled/button__disabled'
     <Button__disabled />
   */
